import { portalLanguageOrDefault } from "../i18nConstants";
import { useTranslation } from "react-i18next";
import React, { FC, ReactNode } from "react";

/**
 * Renders the children as a localized list, using Intl.ListFormat and the given options
 **/
export const LocalizedList: FC<{
  children: [key: string, ReactNode][];
  options?: Intl.ListFormatOptions;
}> = ({ children, options = { style: "short", type: "unit" } }) => {
  const { i18n } = useTranslation();
  const locale = portalLanguageOrDefault(i18n.language);

  // format() can only join strings. formatToParts() returns the same list, split
  // into "element" (our items) and "literal" (locale separators like ", "). We
  // pass field keys as placeholders, then swap each element part for that
  // field's JSX.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/formatToParts
  const listParts = new Intl.ListFormat(locale, options).formatToParts(
    children.map(([key]) => key)
  );

  const childrenByKey = Object.fromEntries(children);

  return (
    <>
      {listParts.map((part, partIndex) =>
        part.type === "element" ? (
          childrenByKey[part.value]
        ) : (
          <span key={`sep-${partIndex}`}>{part.value}</span>
        )
      )}
    </>
  );
};
